// My Deck Runith Over's tick count (§31 A11), in the tick.
//
// Every machine pass of `owner`'s factory — a move's tick, End Turn's,
// Off-Turn Production, a bought tick, the Gambit's — is one of `owner`'s
// factory ticks, and `runMachines` is the one body they all run. Each House of
// Cards whose Knuckles `owner` powers counts it on the House
// (`Structure.dealt`); `payHouseOfCards` turns every
// `ARTIFACTS_LATE.houseTicks` into a card reward at the command's end, where
// the run and the seed are.

import { gearOf, gearPowered } from "./gear";
import { HOUSE_OF_CARDS, type IndustryState, structureAt } from "./state";

/** Count one tick of `owner`'s factory on every House of Cards it powers. */
export function tallyHouseTicks(industry: IndustryState, owner: number): void {
  if (!industry.gear) return;
  for (const gear of gearOf(industry)) {
    if (gear.kind !== HOUSE_OF_CARDS || gear.side !== owner || !gearPowered(industry, gear)) continue;
    const house = structureAt(industry, gear.anchor)!;
    house.dealt = (house.dealt ?? 0) + 1;
  }
}
